export default "__VITE_ASSET__BnzL70oj__"